import { Box, Typography } from "@mui/material";
import React from "react";

const footer = () => {
  return (
    <Box sx={{ textAlign: "center", marginTop: 3, color: "#757575" }}>
      <Typography variant="caption">
        © 2026 Gestão de Documentos. Todos os direitos reservados.
      </Typography>
    </Box>
  );
};

export default footer;
